<template>
    <CRow class="justify-content-center home-form">
        <CCol xl="9" style="max-width: 950px">
            <CCard class="mb-5">
                <CCardHeader class="d-flex align-items-center">
                    <span>Upload video</span>
                    <CButton class="p-0 ml-auto" @click="deleteThis()">
                        <!--suppress HtmlUnknownTag -->
                        <CIcon size="lg" style="color:#977a7a" name="cilX"/>
                    </CButton>
                </CCardHeader>
                <CCardBody>
                    <CRow class="justify-content-center align-items-center">
                        <CCol md="6" class="pr-4">
                            <div v-if="selectedVideoFile" class="mb-3">
                                <strong class="mr-2">
                                    {{ selectedVideoFile.name }}
                                </strong>
                                <CButton class="p-0 ml-auto" @click="onDeleteSelectedVideoFile()">
                                    <!--suppress HtmlUnknownTag -->
                                    <CIcon size="sm" style="color:#c28585" name="cilX"/>
                                </CButton>
                            </div>

                            <div v-if="this.videoUploadingState==='uploading'" class="mb-3"><span>Uploading...</span></div>
                            <CProgress v-if="this.videoUploadingState==='uploading'" class="mb-4" height="20px"
                                       color="info"
                                       show-percentage :value="uploadingProgress"/>
                            <input
                                v-show="false"
                                type="file"
                                ref="videoInput"
                                @change="onVideoSelected($refs.videoInput.files[0])"
                            >
                            <CButton
                                v-if="!selectedVideoFile"
                                color="info"
                                style="min-width:150px"
                                class="mt-4 px-4 mb-3"
                                @click.prevent="$refs.videoInput.click()"
                            >
                                Choose video
                            </CButton>
                            <p v-if="videoUploadingState === 'uploadingError'" style="color:#de2727">{{ uploadingErrorText }}: video
                                uploading
                                failed<br> Click to
                                <CLink style="color:#3b5998" @click.prevent="onVideoSelected(selectedVideoFile)">retry</CLink>
                            </p>
                            <p v-if="videoUploadingState === 'badFileError'" style="color:#de2727">{{ badFileErrorText }}</p>
                            <p v-if="videoUploadingState === 'uploaded'">
                                <strong style="color:#2eb85c" class="mr-2">
                                    The video was uploaded successfully
                                </strong>
                            </p>
                        </CCol>
                        <CCol md="6">
                            <CForm @submit.prevent="requestAnalysis">
                                <CRow class="justify-content-between  mb-1">
                                    <CCol>
                                        <CInputRadioGroup
                                            class="mb-3 home-form__radio"
                                            :checked.sync="equipmentType"
                                            custom
                                            :options="getEquipmentType"
                                            @update:checked="onSelectorChanged"
                                        />
                                    </CCol>
                                    <CCol sm="6" class="video-types" v-if="equipmentType === 'Erg'">
                                        <v-select
                                            v-model="ergType"
                                            class="profile-select"
                                            style="height:35px"
                                            :options="ergTypeOptions"
                                            @search="fetchErgOptions"
                                            :placeholder="ergSelectorPlaceholder"
                                            @search:blur="setErgSelectorPlaceholder(false)"
                                            @search:focus="setErgSelectorPlaceholder(true)"
                                            label="label"
                                            @input="onSelectorChanged"
                                        >
                                            <template #search="{events, attributes}">
                                                <!--suppress HtmlFormInputWithoutLabel -->
                                                <input class="vs__search" v-on="events" v-bind="attributes" maxlength="30"/>
                                            </template>
                                            <template #list-footer="{filteredOptions, search}">
                                                <li class="p-3" v-if="filteredOptions.length === 1 && search && filteredOptions[0].customInput"
                                                    style="text-align: center">
                                                    Click to set the custom producer
                                                </li>
                                                <li class="p-3" v-if="filteredOptions.length > 1 && search">Select from the list or click to set the
                                                    custom one
                                                </li>
                                                <li class="p-3" v-if="filteredOptions.length > 1 && !search">Select or input custom producer</li>
                                            </template>
                                            <template #option="option">
                                                <template v-if="!option.customInput">{{ option.label }}</template>
                                                <template v-else><i>{{ option.label }}</i></template>
                                            </template>
                                        </v-select>
                                    </CCol>
                                    <CCol sm="6" class="video-types" v-if="equipmentType === 'Boat'">
                                        <select
                                            v-model="boatType"
                                            class="profile-select"
                                            style="height:35px; border-color: #d8dbe0;background-color: white; color: #3c4b64;min-width: 100%;"
                                            @change="onSelectorChanged"
                                        >
                                            <option value="" disabled selected hidden>Select crew</option>

                                            <option
                                                v-for="boatOption in getBoatTypeOptions['enabled']"
                                                :key="boatOption.value"
                                                :value="boatOption.value">{{ boatOption.label }}</option>

                                            <template v-if="getBoatTypeOptions['disabled'] && getBoatTypeOptions['disabled'].length > 0">
                                                <optgroup label="Out of your plan">
                                                    <option v-for="option in getBoatTypeOptions['disabled']"
                                                            :value="option.value"
                                                            :disabled="true">{{ option.label }}</option>
                                                </optgroup>
                                            </template>
                                        </select>
                                    </CCol>
                                </CRow>
                                <template v-if="showAdditionalSelectors">
                                    <CRow v-for="seatNum in seatNums" :key="seatNum"
                                          class="video-select justify-content-between align-items-center mt-2">
                                        <CCol sm="6" :style="participantsQty > 1 ? 'margin-bottom: -22px' : ''">
                                            <label class="mb-0" v-if="seatNum === 1">
                                                <template v-if="participantsQty !== 1">
                                                    Set the crew
                                                    <br>
                                                    (optional)
                                                </template>
                                                <template v-else>
                                                    Who is on video
                                                </template>
                                            </label>
                                        </CCol>
                                        <CCol sm="6">
                                            <v-select
                                                :class="{
                                                    'profile-select': true,
                                                    'mt-4': seatNum === 1 && participantsQty !== 1,
                                                    'mt-sm-0': seatNum === 1 && participantsQty !== 1
                                                }"
                                                style="height:35px"
                                                :options="participantOptions[seatNum]"
                                                :placeholder="participantSelectorPlaceholder[seatNum]"
                                                @search:blur="setParticipantSelectorPlaceholder(false, seatNum)"
                                                @search:focus="setParticipantSelectorPlaceholder(true, seatNum)"
                                                @search="fetchParticipantOptions($event, arguments[1], seatNum, participant, participantCustomName)"
                                                label="username"
                                                @input="setParticipant($event, seatNum)"
                                            >
                                                <template #list-footer="{filteredOptions, search}">
                                                    <li class="p-3" v-if="filteredOptions.length === 1 && search && filteredOptions[0].id.startsWith('@')"
                                                        style="text-align: center">
                                                        Click to set the custom name
                                                    </li>
                                                    <li class="p-3" v-if="filteredOptions.length > 1 && search">
                                                        Select from the list or click to set the custom name
                                                    </li>
                                                    <li class="p-3" v-if="!search">
                                                        Search username or input custom name
                                                    </li>
                                                </template>
                                                <template #no-options="{}">
                                                    <div></div>
                                                </template>
                                                <template #search="{events, attributes}">
                                                    <!--suppress HtmlFormInputWithoutLabel -->
                                                    <input class="vs__search" v-on="events" v-bind="attributes" maxlength="50"/>
                                                </template>
                                                <template #option="option">
                                                    <template v-if="option.id && !option.id.startsWith('@')">{{ option.username }}</template>
                                                    <template v-else><i>{{ option.username }}</i></template>
                                                </template>
                                            </v-select>
                                        </CCol>
                                    </CRow>
                                    <CRow class="video-select justify-content-between align-items-center mt-3 mb-1">
                                        <CCol sm="6" :class="{'d-flex': this.profileSearchFocused, 'd-sm-none': this.profileSearchFocused}">
                                            <label class="mb-0" @click="showTrainingProfileConfiguration=!showTrainingProfileConfiguration && !isCustomStylesDisabled">
                                                Rowing style
                                                <img src="../assets/img/sort-down.svg" alt="">
                                            </label>
                                        </CCol>
                                        <CCol :sm="profileSearchFocused ? 12 : 6">
                                            <v-select
                                                class="profile-select"
                                                style="height:35px"
                                                :options="trainingProfileOptions"
                                                :clearable="false"
                                                @search="fetchTrainingProfileOptions"
                                                @input="setTrainingProfileOption"
                                                label="name"
                                                :value="this.trainingProfileValue"
                                                ref="TrainingProfileSelector"
                                                @search:focus="profileSearchFocused=true"
                                                @search:blur="profileSearchFocused=false"
                                            >
                                                <template #list-header>
                                                    <li :class="'p-3' + (isCustomStylesDisabled ? ' disabled' : '')">
                                                        Select style or
                                                        <CLink :disabled="isCustomStylesDisabled" class="option-link" style="font-weight:600" @click.prevent="createNewTrainingProfile">create
                                                            new<!--
                                                        --></CLink>. Check
                                                        <CLink class="option-link" style="font-weight:600" href="/faq#rowing-styles" target="_blank">
                                                            styles FAQ</CLink> for more info
                                                        <strong v-if="isCustomStylesDisabled">- out of your plan</strong>
                                                    </li>
                                                </template>

                                                <template #option="option">
                                                    <template v-if="option.isGlobal"><span style="position: relative;">{{ option.name }} <span style="position: absolute; left: 125px; width: 285px">{{ option.description }}</span></span></template>
                                                    <template v-else><i>{{ option.name }}</i></template>
                                                </template>
                                            </v-select>
                                        </CCol>
                                    </CRow>

                                    <template v-if="showTrainingProfileConfiguration">
                                        <TrainingProfileConfiguration :trainingProfile="this.trainingProfileConfigurationValue"
                                                                      @newConfiguration="onNewTrainingProfileConfiguration"
                                                                      ref="TrainingProfileConfiguration"
                                                                      @trainingProfileDeleted="onTrainingProfileDeleted"
                                                                      @trainingProfileChanged="trainingProfileChanged"
                                                                      @outerNewTrainingProfileCanceled="onOuterNewTrainingProfileCanceled"
                                                                      @trainingProfileEditStart="onTrainingProfileEditStart"
                                                                      @trainingProfileEditStop="onTrainingProfileEditStop"
                                        />
                                    </template>
                                    <label class="mt-3" @click="showTrainingSettings=!showTrainingSettings">
                                        Sharing and privacy
                                        <img src="../assets/img/sort-down.svg" alt="">
                                    </label>

                                    <template v-if="showTrainingSettings">
                                        <CRow class="radio-profile mb-1">
                                            <CCol class="mb-1">
                                                <CInputRadioGroup
                                                    custom
                                                    class="home-form__radio d-flex flex-wrap mt-0"
                                                    :options="privacyOptions"
                                                    :checked.sync="privacy"
                                                    required
                                                    @update:checked="onSelectorChanged"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow v-for="(customPrivacyId, i) in customPrivacyIds" :key="customPrivacyId+10" class="mb-2 justify-content-between align-items-center">
                                            <CCol sm="6">
                                                <label class="mb-0" v-if="i === 0">Share with more people</label>
                                            </CCol>
                                            <CCol sm="6">
                                                <v-select
                                                    class="profile-select"
                                                    style="height:35px"
                                                    :placeholder="i === 0 ? 'Select user' : 'Share with user'"
                                                    @search="fetchCustomPrivacyOptions"
                                                    @input="setCustomPrivacyUser($event, customPrivacyId)"
                                                    :options="customPrivacySearchOptions"
                                                    label="username"
                                                >
                                                    <template #list-footer="{filteredOptions, search}">
                                                        <li class="p-1 pl-3 pr-3" v-if="!search">
                                                            Search username
                                                        </li>
                                                        <li class="p-1 pl-3 pr-3" v-else-if="search && !filteredOptions.length">
                                                            User not found
                                                        </li>
                                                    </template>
                                                    <template #no-options="{}">
                                                        <div></div>
                                                    </template>
                                                    <template #search="{events, attributes}">
                                                        <!--suppress HtmlFormInputWithoutLabel -->
                                                        <input class="vs__search" v-on="events" v-bind="attributes" maxlength="50"/>
                                                    </template>
                                                </v-select>
                                            </CCol>
                                        </CRow>
                                    </template>
                                </template>
                                <CRow v-if="store.showStaffControls">
                                    <CCol sm="12">
                                        <CInputCheckbox
                                            label="Do not process this video (proceed configuration in admin panel)"
                                            :checked.sync="doNotProcess"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                    <CCol class="text-right">
                                        <p v-if="videoUploadingState === 'uploading' && this.analysisRequested" style="color:#2eb85c">
                                            Analysis of video will start after uploading finishes.</p>
                                        <div v-if="submitTrainingErrors && submitTrainingErrors.length">
                                            <p style="color:#de2727" v-for="err in submitTrainingErrors">
                                                {{ err.fieldName }}{{ (err.fieldName && err.message) ? ': ' : '' }}{{ err.message }}
                                            </p>
                                        </div>
                                    </CCol>
                                </CRow>
                                <CRow :class="showTrainingSettings ? 'mt-3' : ''">
                                    <CCol sm="12" class="ml-auto text-right">
                                        <CButton
                                            style="min-width:150px"
                                            color="success"
                                            class="px-5"
                                            type="submit"
                                            :disabled="analysisRequested || isOverAnalysisLimit()"
                                        >
                                            {{ analysisRequested ? 'Analysis pending' : 'Analyze' }}
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <CRow v-if="analysisRequested">
                                    <CCol sm="12">
                                        <div class="text-right mt-4">
                                            <CButton
                                                style="min-width:150px"
                                                color="dark"
                                                class="px-4 ml-auto"
                                                @click="addOneMore"
                                            >
                                                Add more video
                                            </CButton>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CForm>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import axios from 'axios'
    import {backendURL} from '@/scripts/globals'
    import gql from "graphql-tag"
    import {apolloClient} from '@/plugins/apollo'
    import {getErrorsByExcApolloExc, getProcessedResponseErrorsFlat} from '@/scripts/forms-utils'
    import trainingParticipantsAndPrivacyMixin from '@/mixins/training-participants-and-privacy'
    import {store} from '@/scripts/globals'
    import TrainingProfileConfiguration from '@/components/TrainingProfileConfiguration'
    import {trainingProfileSearch} from "@/scripts/queries";
    import {hasPermission, isOverAnalysisLimit} from "@/scripts/auth-utils";

    let defaultTrainingProfileValueBoat = {name: 'Classic style I', id: 1, isGlobal: true, description: '(LBA | steady state | boat angles)'}
    let defaultTrainingProfileValueErg = process.env.VUE_APP_EXECUTON_ENV  === 'PROD' ? {name: 'Classic style II', id: 12046, isGlobal: true, description: '(LBA | steady state | erg angles)'} : defaultTrainingProfileValueBoat

    Date.prototype.toDateInputValue = (function () {
        // noinspection JSCheckFunctionSignatures
        let local = new Date(this);
        local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
        return local.toJSON().slice(0, 10);
    });

    Date.prototype.toTimeInputValue = (function () {
        let local = new Date(this);
        local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
        return local.toJSON().slice(11, 16);
    });

    let baseErgTypeOptions = [
        {value: 'Concept2', label: 'Concept2'},
        {value: 'Concept2 on slides', label: 'Concept2 on slides'},
        {value: 'RP3', label: 'RP3'},
        {value: 'Hydrow', label: 'Hydrow'},
        {value: 'WaterRower', label: 'WaterRower'},
        {value: 'Ergatta', label: 'Ergatta'},
        {value: 'Matrix', label: 'Matrix'},
        {value: 'NordicTrack', label: 'NordicTrack'},
        {value: 'Sunny H&F', label: 'Sunny H&F'},
    ]

    export default {
        mixins: [trainingParticipantsAndPrivacyMixin],
        props: {
            videoFile: {}
        },
        components: {
            TrainingProfileConfiguration
        },
        data() {
            return {
                store,
                showTrainingSettings: false,
                showTrainingProfileConfiguration: false,
                trainingProfileEditActive: false,
                profileSearchFocused: false,

                selectedVideoFile: null,
                videoUploadingState: ['initial', 'uploading', 'uploadingError', 'badFileError', 'uploaded'][0],
                uploadedFileId: null,
                badFileErrorText: '',
                uploadingErrorText: '',
                uploadingProgress: 0,
                analyzeVideoAfterUpload: false,
                axiosCancelTokenSource: null,

                equipmentType: null,
                analysisRequested: false,
                submitTrainingErrors: [],
                ergSelectorPlaceholder: '',
                ergType: '',
                ergTypeOptions: baseErgTypeOptions,
                boatType: '',
                boatTypeOptions: [
                    {permission: 'create_training_seats_1', options: [
                        {value: 'Crew1x', label: '1x'},
                    ]},
                    {permission: 'create_training_seats_2', options: [
                        {value: 'Crew2_m', label: '2-'},
                        {value: 'Crew2_p', label: '2+'},
                        {value: 'Crew2x', label: '2x'},
                        {value: 'Crew2x_p', label: '2x+'},
                    ]},
                    {permission: 'create_training_seats_4', options: [
                        {value: 'Crew4_m', label: '4- (beta)'},
                        {value: 'Crew4_p', label: '4+ (beta)'},
                        {value: 'Crew4x', label: '4x (beta)'},
                        {value: 'Crew4x_p', label: '4x+ (beta)'},
                    ]},
                    {permission: 'create_training_seats_8', options: [
                        {value: 'Crew8_m', label: '8- (beta)'},
                        {value: 'Crew8_p', label: '8+ (beta)'},
                        {value: 'Crew8x', label: '8x (beta)'},
                        {value: 'Crew8x_p', label: '8x+ (beta)'}
                    ]},
                ],
                trainingProfileValue: null,
                trainingProfileOptions: [],
                trainingProfileConfigurationValue: null,
                doNotProcess: false,
                hasPermission
            }
        },
        methods: {
            isOverAnalysisLimit,
            setErgSelectorPlaceholder(focus) {
                if (focus)
                    this.ergSelectorPlaceholder = ''
                else
                    this.ergSelectorPlaceholder = 'Set producer'
            },
            fetchErgOptions(search, loading) {
                loading(true)
                if (search) {
                    this.ergTypeOptions = baseErgTypeOptions.filter(e => e.value.startsWith(search))
                    let foundFlag = false
                    for (let ergType of this.ergTypeOptions)
                        if (ergType.value === search)
                            foundFlag = true
                    if (!foundFlag)
                        this.ergTypeOptions.unshift({label: search, value: search, customInput: true})
                } else {
                    this.ergTypeOptions = baseErgTypeOptions
                }
                loading(false)
            },
            async fetchTrainingProfileOptions(search, loading) {
                if (!search)
                    search = ''

                if (loading)
                    loading(true)

                let firstN
                if (search)
                    firstN = 5
                else
                    firstN = 99

                this.trainingProfileOptions = await trainingProfileSearch(search, firstN)
                if (loading)
                    loading(false)
            },
            setTrainingProfileOption(val) {
                this.trainingProfileValue = val
                this.trainingProfileConfigurationValue = this.trainingProfileValue
            },
            createNewTrainingProfile() {
                this.showTrainingProfileConfiguration = true
                this.$refs.TrainingProfileSelector.onAfterSelect()
                this.trainingProfileConfigurationValue = null
            },
            trainingProfileChanged(trainingProfile, close) {
                this.onSelectorChanged()
                this.trainingProfileValue = trainingProfile
                this.trainingProfileConfigurationValue = this.trainingProfileValue
                if (close)
                    this.showTrainingProfileConfiguration = false
                this.fetchTrainingProfileOptions()
            },
            onTrainingProfileDeleted() {
                this.onSelectorChanged()
                this.trainingProfileValue = this.equipmentType === 'Erg' ? defaultTrainingProfileValueErg : defaultTrainingProfileValueBoat
                this.trainingProfileConfigurationValue = this.trainingProfileValue
                this.fetchTrainingProfileOptions()
                this.showTrainingProfileConfiguration = false
            },
            onOuterNewTrainingProfileCanceled() {
                this.showTrainingProfileConfiguration = false
                this.trainingProfileConfigurationValue = this.trainingProfileValue
            },
            onSelectorChanged() {
                this.submitTrainingErrors = []
                this.cancelAnalysis()
            },
            onNewTrainingProfileConfiguration(evt, newTrainingProfile) {
                this.onSelectorChanged()
                this.trainingProfileValue = newTrainingProfile
                this.trainingProfileConfigurationValue = this.trainingProfileValue
            },
            cancelAnalysis() {
                this.analysisRequested = false
            },
            requestAnalysis() {

                this.submitTrainingErrors = []

                if (!this.equipmentType) {
                    this.submitTrainingErrors.push(
                        {
                            fieldName: '',
                            message: 'Please select "Erg" or "Boat"'
                        }
                    )
                } else if (this.equipmentType === 'Erg' && !this.ergType) {
                    this.submitTrainingErrors.push(
                        {
                            fieldName: '',
                            message: 'Please select your Erg'
                        }
                    )
                } else if (this.equipmentType === 'Boat' && !this.boatType) {
                    this.submitTrainingErrors.push(
                        {
                            fieldName: '',
                            message: 'Please select your Boat crew'
                        }
                    )
                }
                if (!(this.videoUploadingState === 'uploaded' || this.videoUploadingState === 'uploading')) {
                    this.submitTrainingErrors.push(
                        {
                            fieldName: '',
                            message: 'Please select video file'
                        }
                    )
                }
                if (this.trainingProfileEditActive) {
                    this.submitTrainingErrors.push(
                        {
                            fieldName: '',
                            message: 'Please save edited rowing style'
                        }
                    )
                }


                if (!this.submitTrainingErrors.length)
                    this.analysisRequested = true
            },
            deleteThis() {
                this.$emit('deleteThis')
            },
            addOneMore() {
                this.$emit('addOneMore')
            },
            onDeleteSelectedVideoFile() {
                this.onVideoSelected(false)
            },
            async onVideoSelected(videoFile) {
                if (this.$refs.videoInput)
                    this.$refs.videoInput.value = null
                if (this.axiosCancelTokenSource)
                    this.axiosCancelTokenSource.cancel()
                this.axiosCancelTokenSource = null
                this.uploadedFileId = null
                this.badFileErrorText = ''
                this.uploadingErrorText = ''
                if (this.$refs.videoInput)
                    this.$refs.videoInput.value = null
                this.uploadingProgress = 0
                this.videoUploadingState = 'initial'
                this.selectedVideoFile = videoFile

                if (this.selectedVideoFile) {
                    let filSizeMB = this.selectedVideoFile.size / 1048576
                    if (filSizeMB > parseInt(process.env.VUE_APP_MAX_VIDEO_FILE_SIZE_MB)) {
                        this.videoUploadingState = 'badFileError'
                        // noinspection ES6ShorthandObjectProperty
                        this.badFileErrorText = `Only files less than ${process.env.VUE_APP_MAX_VIDEO_FILE_SIZE_MB}MB are supported (${videoFile.name}: ${parseInt(filSizeMB)}MB)`
                        this.selectedVideoFile = null
                    } else {
                        this.videoUploadingState = 'uploading'
                        let formData = new FormData();
                        formData.append('file', this.selectedVideoFile);
                        let response
                        try {
                            this.axiosCancelTokenSource = axios.CancelToken.source()
                            response = await axios.post(backendURL + '/files/',
                                formData,
                                {
                                    cancelToken: this.axiosCancelTokenSource.token,
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    },
                                    withCredentials: true,
                                    onUploadProgress: progressEvent => this.uploadingProgress =
                                        Math.round(progressEvent.loaded / progressEvent.total * 100)
                                })
                        } catch (e) {
                            if (!axios.isCancel(e)) {
                                if (e.response) {
                                    this.uploadingErrorText = 'Server error'
                                } else {
                                    this.uploadingErrorText = 'Network error'
                                }
                                this.videoUploadingState = 'uploadingError'
                                throw e
                            } else
                                return
                        }

                        this.uploadedFileId = response.data['file_id']
                        if (!this.uploadedFileId) {
                            this.uploadingErrorText = 'Server error'
                            this.videoUploadingState = 'uploadingError'
                            throw Error("Server hasn't returned file id")
                        } else
                            this.videoUploadingState = 'uploaded'

                    }
                }
            },
            onTrainingProfileEditStart() {
                this.trainingProfileEditActive=true
                this.onSelectorChanged()
            },
            onTrainingProfileEditStop() {
                this.trainingProfileEditActive=false
                this.onSelectorChanged()
            },
        },
        created() {
            this.onVideoSelected(this.videoFile)
            this.setErgSelectorPlaceholder(false)
            this.setInitialParticipantPlaceholder()
            this.fetchTrainingProfileOptions()
            this.setBlankSearchParticipantOptions()
            this.addCustomPrivacy()
            if (this.store.myUser.isSuperuser) {
                this.privacy = 'Private'
            }
        },
        computed: {
            videoUploadingStateAndAnalysisRequested() {
                return `${this.videoUploadingState}|${this.analysisRequested}`;
            },
            showAdditionalSelectors() {
                return (this.equipmentType === 'Boat' && this.boatType) || (this.equipmentType === 'Erg' && this.ergType)
            },
            getBoatTypeOptions() {
                let enabled = [];
                let disabled = [];
                this.boatTypeOptions.forEach((group) => {
                    if (group.options) {
                        if (this.hasPermission(group.permission)) {
                            enabled.push(...group.options);
                        } else {
                            disabled.push(...group.options);
                        }
                    }
                });

                return {
                    'enabled': enabled,
                    'disabled': disabled
                };
            },
            getEquipmentType() {
                let erg = {value: 'Erg', label: 'Erg', 'disabled': false};
                let boat = {value: 'Boat', label: 'Boat', 'disabled': false};
                let types = [];

                if (!this.hasPermission('create_training_erg')) {
                    erg['props'] = {disabled: true};
                    erg['label'] = erg['label'] + ' - out of your plan';
                }
                types.push(erg);

                if (!this.hasPermission(/create_training_seats_\d/, true)) {
                    boat['props'] = {disabled: true};
                    boat['label'] = boat['label'] + ' - out of your plan';
                }
                types.push(boat);

                return types;
            },
            isCustomStylesDisabled() {
                return !this.hasPermission('create_training_custom_style');
            }
        },
        watch: {
            equipmentType(newType) {
                if (newType === 'Erg') {
                    this.trainingProfileValue = defaultTrainingProfileValueErg
                    this.trainingProfileConfigurationValue = defaultTrainingProfileValueErg
                }
                else {
                    this.trainingProfileValue = defaultTrainingProfileValueBoat
                    this.trainingProfileConfigurationValue = defaultTrainingProfileValueBoat
                }
            },
            videoUploadingState(newState, oldState) {
                if (!(oldState === 'uploading' && newState === 'uploaded'))
                    this.onSelectorChanged()
            },
            async videoUploadingStateAndAnalysisRequested() {
                if (this.videoUploadingState === 'uploaded' && this.analysisRequested) {
                    let accessForAll = this.privacy === 'Public'
                    let accessForParticipants = this.privacy === 'Participants'
                    let accessForUserIds = []
                    for (let customPrivacyId of this.customPrivacyIds)
                        if (this.customPrivacyOpts[customPrivacyId])
                            accessForUserIds.push(parseInt(this.customPrivacyOpts[customPrivacyId].id))
                    let videos = [{fileId: this.uploadedFileId}]
                    let equipmentType = this.equipmentType
                    let trainingProfileId = this.trainingProfileValue.id

                    let inputTypeVars = {
                        videos,
                        equipmentType,
                        accessForAll,
                        accessForUserIds,
                        accessForParticipants,
                        participant1CustomName: this.participantCustomName[1],
                        participant2CustomName: this.participantCustomName[2],
                        participant3CustomName: this.participantCustomName[3],
                        participant4CustomName: this.participantCustomName[4],
                        participant5CustomName: this.participantCustomName[5],
                        participant6CustomName: this.participantCustomName[6],
                        participant7CustomName: this.participantCustomName[7],
                        participant8CustomName: this.participantCustomName[8],
                        participant1Id: this.participant[1] ? this.participant[1].id : null,
                        participant2Id: this.participant[2] ? this.participant[2].id : null,
                        participant3Id: this.participant[3] ? this.participant[3].id : null,
                        participant4Id: this.participant[4] ? this.participant[4].id : null,
                        participant5Id: this.participant[5] ? this.participant[5].id : null,
                        participant6Id: this.participant[6] ? this.participant[6].id : null,
                        participant7Id: this.participant[7] ? this.participant[7].id : null,
                        participant8Id: this.participant[8] ? this.participant[8].id : null,
                        doNotProcess: this.doNotProcess,
                        trainingProfileId
                    }

                    if (this.equipmentType === 'Erg')
                        inputTypeVars.ergType = this.ergType.value
                    if (this.equipmentType === 'Boat')
                        inputTypeVars.boatType = this.boatType

                    let mutation = gql`
                        mutation addTraining ($addTraining: AddTrainingInputType!){
                            addTraining (addTraining: $addTraining)
                            {
                                training {
                                    id
                                }
                            }
                        }
                        `

                    try {
                        await apolloClient.mutate({
                            mutation,
                            variables: {addTraining: inputTypeVars}
                        })
                    } catch (e) {
                        this.submitTrainingErrors = getProcessedResponseErrorsFlat(getErrorsByExcApolloExc(e))
                        this.cancelAnalysis()
                        throw e
                    }
                    this.$emit('submitted')
                }
            }
        }
    }
</script>

<style lang="scss">
    .option-link {
        color: #3b5998;
    }
    .disabled {
        color: #8a93a2;
    }
    .option-link.disabled {
        text-decoration: underline;
    }
</style>